import axios from 'axios'

const url = 'https://webmr.cl/api-covid19/api'


export async function getRegiones() {
    let zones = await axios.get(`${url}/areas?mostrar=regiones`)
    zones.data.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
    return zones.data.data.map(zone => {
        return {
            text: zone.nombre,
            value: zone.id
        }
    })
}

export async function getVacunacionMundial() {
    let paises = await axios.get(`${url}/vacunacion/listar/data/mundial`)
    return paises.data.data.map(element => {
        return {
            pais: element['País'],
            inmunizados: element['Porcentaje población inmunizada'],
            background: element['Background']
        }
    })
}

export async function getPorcentajeInmunizados() {
    let regiones = await axios.get(`${url}/vacunacion/listar/cobertura/vacunacion`)
    return {
        data: regiones.data.data
    }
}

export async function getInmunizacionChile() {
    let regiones = await axios.get(`${url}/vacunacion/listar/regiones/inmunidad`)
    return {
        data: regiones.data.data
    }
}


